import classNames from 'clsx'
import { arrayOf, bool, objectOf, oneOfType, string } from 'prop-types'

import setInnerHTML from 'views/utils/setInnerHTML'

import './CmsInfoText.scss'

function CmsInfoText({ className, children }) {
  if (children == null) {
    return null
  }

  return (
    <section
      className={classNames('m-CmsInfoText u-userContent', className)}
      {...setInnerHTML(children)}
    />
  )
}

CmsInfoText.propTypes = {
  className: oneOfType([string, arrayOf(string), objectOf(bool)]),
  children: string,
}

CmsInfoText.defaultProps = {
  className: null,
  children: null,
}

export default CmsInfoText
